import { useState } from "react";
import { Link } from "react-router-dom";
import { PageHeader } from "@/components/PageUI";
import { GuideBody } from "@/components/GuideButton";
import { GUIDES } from "@/lib/guides";
import { canUseStudio } from "@/lib/creative";
import { useAuth } from "@/context/AuthContext";
import { ArrowRight } from "lucide-react";

const slug = t => t.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export default function HelpCenter() {
  const { user } = useAuth();
  const guides = GUIDES.filter(g => (g.group !== "AI Video Studio" || canUseStudio(user)) && (g.path !== "/admin" || user?.role === "admin") && g.path !== "/payment");
  const [open, setOpen] = useState(guides[0].title);
  const groups = [...new Set(guides.map(g => g.group))];
  return <><PageHeader eyebrow="Help center" title="How everything works." description="A short guide for every section. Tip: the Guide button at the top of any page opens the guide for that page." />
    <div className="help-grid" data-testid="help-center-page">
      <nav className="help-toc" data-testid="help-center-toc">{groups.map(gr => <div key={gr}><span className="nav-section-label">{gr}</span>
        {guides.filter(g => g.group === gr).map(g => <button key={g.title} className={open === g.title ? "active" : ""} onClick={() => setOpen(g.title)} data-testid={`help-topic-${slug(g.title)}`}>{g.title}</button>)}</div>)}</nav>
      {guides.filter(g => g.title === open).map(g => <article className="panel help-article" key={g.title} data-testid={`help-article-${slug(g.title)}`}>
        <span className="eyebrow">{g.group}</span><h2>{g.title}</h2><p className="help-intro">{g.intro}</p><GuideBody guide={g} />
        {!["/studio/projects", "/help", "/creators"].includes(g.path) && <Link to={g.path} className="primary-btn" data-testid={`help-open-${slug(g.title)}`}>Open {g.title} <ArrowRight size={15} /></Link>}
      </article>)}
    </div></>;
}
